import React from 'react';
import german_translation from "./de";
import english_translation from "./en";

export const TranslationContext = React.createContext({});
TranslationContext.displayName = 'TranslationContext';

export const TranslationProvider = (props) => {
    const {language, children} = props;

    const translations = {
        de: german_translation,
        en: english_translation,
    }

    const t = (key) => {
        return translations[language][key] || '';
    }

    return <TranslationContext.Provider value={{t, language}}>
        {children}
    </TranslationContext.Provider>;
}
